<template>
  <div style="margin-left: 0px;">
    <div v-if="debug_show_page_name==true" style="color:green;">sub-table-temp-certificate-information</div>
    <div :class="'container ' + pageContainerSize">
      <ag-grid-vue style="width: 100%; height: 445px" class="ag-blue" :gridOptions="gridOptions"></ag-grid-vue>
      <br>
    <div class="row " style="margin-top: 10px;">
      <div class="col-xs-4">
        <span style="float: left;">件数</span>
        <input type="text" data-cy="totalNumberOfRows" style="margin-left:5px;float: left;width: 100px;text-align: right;" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
      </div>
      <div class="col-xs-8">
        <div class="row" style="margin-bottom: 5px; padding: 0px 10px;" v-show="showRetractionReason">
            <label class="col-xs-4 control-label esma_form_label">差戻理由 </label>
            <div class="col-xs-8 select-box4" style="padding: 1px 0px 0px 7px;margin-bottom: -15px;">
                <textarea
                :disabled="disableRetractionReason"
                v-model="retractionReasonValue"
                placeholder=""
                rows="3"
                class="form-control"
                style="height: 60px !important;"></textarea>
                <br>
            </div>
            <div class="col-xs-4 "> </div>
            <div class="col-xs-8 " style="padding: 0px 0px 20px 7px;">
              <button
                v-if="disableRetractionReason == true && disableEditRetractionReason == false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 0px;background: #FF7C80;;background: #337ab7;margin-top: 30px;" 
                @click="disableRetractionReason = false"
                >編集</button>
              <button 
                v-if="disableRetractionReason == false" 
                :disabled="false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 0px;background: #A6A6A6;margin-top: 30px;" 
                @click="cancelRetractionReason()"
                >ｷｬﾝｾﾙ</button>
              <button
                v-if="disableRetractionReason == false"
                @click="saveRetractionReason()"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;;background: #337ab7;margin-top: 30px;" 
                >入力完了</button>
                <span v-if="disableRetractionReason == true && disableEditRetractionReason == false">
                 <span style='float: right;
                         font-size: 15px;
                         margin-right: 0px;
                         font-weight: 800;
                         margin-top:-65px;
                         letter-spacing: 1px;
                         color:red;'
                    >※入力完了後、戻るボタンをクリックして、申請承認画面から差戻をしてください。
                 </span>
               </span>
                <span v-if="disableRetractionReason == false">
                 <span style='float: right;
                         font-size: 15px;
                         margin-right: 145px;
                         font-weight: 800;
                         margin-top:-65px;
                         letter-spacing: 1px;
                         color:red;'
                    >※差戻通知を入力し、入力完了をクリックしてください。(任意)
                 </span>
               </span>

            </div>
        </div>
      <div class="row" style="margin-bottom: 5px; padding: 0px 10px;">
        <div class="col-xs-12">
          <div style="color: white; margin: 2px 0px; padding: 2px 5px; text-align: end; width: 90%; float: right; background-color: orange; display: none;"></div>
          <a :href="downloadUrl"  :target="downloadUrl" class="btn btn-lg btn-primary" style="float: right;">出力</a>
          <button
            v-if="showConfirmedBtn"
            @click="onRejectedConfirmed"
            class="btn btn-primary" style="float: right;margin-right: 20px;"
            >確認済</button>
          <button v-show="countErrors > 0 && filerByError == false" class="btn btn-warning" style="float: right;margin-right: 20px;" @click="filterOnlyErrors" >エラー詳細</button>
          <button v-show="countErrors > 0 && filerByError == true" class="btn btn-warning" style="float: right;margin-right: 20px;" @click="filterAll" >戻る</button>
        </div>
      </div>
    </div>
    </div>
    </div>
    <confirmation-modal tag="onRejectedConfirmedModal" @done="onRejectedConfirmedStep2" />
  </div>
</template>

<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_temp_batch_import";
import { utils } from "@/libs/utils";

import _debug from "debug";

var mdebug = _debug("esma:master_user");
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "ag-grid-vue": AgGridVue
  },
  data() {
    return {
      api_name: "batch_import_export",
      page_acl: acl.generic,
      allow_check_box:false,
      get_row_style_background:"#ffb5b5",
      save_check_event:false,
      download_url:"",
      count_errors:0,
      filer_by_error:false,
      show_confirmed_btn:false,
      initial_retraction_reason:"",
      retraction_reason_value:"",
      disable_retraction_reason:true,
      approval_status: "",
      local_seq_id:false,
      disable_edit_retraction_reason:false,
      cancelable_arr:[]
    };
  },
  computed: {
    cancelableArr:{
      get(){
        return this.cancelable_arr;
      },
      set(v){
        this.cancelable_arr = v;
      }
    },
    disableEditRetractionReason:{
      get(){
        return this.disable_edit_retraction_reason;
      },
      set(v){
        this.disable_edit_retraction_reason = v;
      }
    },
    initialRetractionReason:{
      get(){
        return this.initial_retraction_reason;
      },
      set(v){
        this.initial_retraction_reason = v;
      }
    },
    showRetractionReason(){
      return this.formOutputQty > 0;
    },
    retractionReasonValue:{
      get(){
        return this.retraction_reason_value;
      },
      set(v){
        this.retraction_reason_value = v;
      }
    },
    localSeqId:{
      get(){
        return this.local_seq_id;
      },
      set(v){
        this.local_seq_id = v;
      }
    },
    disableRetractionReason:{
      get(){
        return this.disable_retraction_reason;
      },
      set(v){
        this.$emit("editing",v == false)
        this.disable_retraction_reason = v;
      }
    },
    showConfirmedBtn:{
      get(){
        return this.show_confirmed_btn;
      },
      set(v){
        this.show_confirmed_btn = v;
      }
    },
    filerByError:{
      get(){
        return this.filer_by_error;
      },
      set(v){
        this.filer_by_error = v;
      }
    },
    countErrors:{
      get(){
        return this.count_errors;
      },
      set(v){
        this.count_errors = v;
      }
    },
    downloadUrl:{
      get(){
        return this.download_url;
      },
      set(v){
        this.download_url = v;
      }
    },
    saveCheckEvent:{
      get(){
        return this.save_check_event;
      },
      set(v){
        this.save_check_event = v;
      }
    },
    getRowStyleBackground:{
      get(){
        return this.get_row_style_background;
      },
      set(v){
        this.get_row_style_background = v;
      }
    },
    localAllowCheckBox:{
      get(){
        return this.allow_check_box;
      },
      set(v){
        this.allow_check_box = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields() {
      return this.tabFieldList;
    },
    values() {
      console.log("values");
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return _.filter(fields.array,(f)=>{return f.import_details.p != null && f.id != "more_details" && f.id != "button_options"})
    },
    tabFieldList2() {
      var remove_fields = [ "ci_mb_department_code", "ci_licensed_department", "ci_mb_team_code", "ci_license_jurisdiction_team", 
          "ci_jurisdiction_classification", "ci_ms_system_code", "ci_license_jurisdiction_system", "ci_equipment_in_charge_system", 
          "ci_license_certificate_type", "ci_certificate_individual_number", "ci_mm_seq_id", "ci_maker", "ci_applicant_name", 
          "ci_management_person_name", "ci_comprehensive_contract", "ci_sales_company", "ci_deadline_alert", "ci_expiration_date", 
          "ci_maintenance_deadline", "ad_license_name", "ad_ms_software_code", "ad_software_name", "ad_product_key", "ad_unlimited", 
          "ad_second", "ad_second_number"];
      var r =  _.filter(fields.array,(f)=>{
        return f.import_details.p != null && f.id != "more_details" && f.id != "button_options" && remove_fields.indexOf(f.id) < 0
      })
      return r;
    },
  },
  methods: {
    hideCheckBox(data){
      return this.localAllowCheckBox == false;
    },
    onRejectedConfirmed(){
      bus.$emit("onRejectedConfirmedModal",{
        title: "確認済",
        message: "承認状態を確認済に変更します",
        yes_label: "OK",
        no_label: "戻る",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    onRejectedConfirmedStep2(mode){
      if(mode == "yes"){
        if(this.localSeqId !== false){
          var opt= {
            changes:{
              approval_status:"確認済"
            }
          }
          this.$ajax.post('/approval_history_batch_import/set/' +this.localSeqId  , opt, (err, result) => {
            setTimeout(() => {
              return this.$router.push("/approval_history/all/rejected");
            }, 1000);
          });
        }
      }
    },
    showErrroCount(){
      if(this.countErrors > 0){
        this.$emit("onerror","取込データに" + this.countErrors + "行のエラーがあります。")
      }else{
        this.$emit("onerror","")
      }
    },
    filterAll(){
      this.showErrroCount();
      this.filerByError = false;
      this.api_request_options = {filter_mode:"show_all",sessionId:this.sessionId };
      this.emulateSearchControlChangedDatasource(true)
    },
    filterOnlyErrors(){
      this.showErrroCount();
      this.filerByError = true
      this.api_request_options = {filter_mode:"only_error", sessionId:this.sessionId };
      this.emulateSearchControlChangedDatasource(true)
    },
    onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs(field_list_name="tabFieldList") {
      return this.commonCreateColumnDefs({show_checkbox:this.localAllowCheckBox,field_list_name})
    },
    cellStyle(params) {
      if(params.data){
        if(params.data.has_error){
          if(params.data.error_type && typeof params.data.error_type == "string"){
            params.data.error_type = JSON.parse(params.data.error_type)
          }
          if(params.data.error_link && typeof params.data.error_link == "string"){
            params.data.error_link = JSON.parse(params.data.error_link)
          }
        }
        if(_.find(params.data.error_type,(f)=>{return f.field_id == params.colDef.field })){
          return {color:'black', backgroundColor: 'rgba(255, 165, 0 , 0.5)'};
        }else if(_.find(params.data.error_link,(f)=>{return f.field_id == params.colDef.field })){
          return {color:'black', backgroundColor: 'rgba(255, 165, 0 , 0.5)'};
        }else{
          return null;
        }

      }
    },
    onRowSelected(params) {
      this.selected_row = params.node.data.seq_id;
      this.showErrros(params.node.data)
    },
    showErrros(data){
      if(data.has_error != 1){
        this.showErrroCount();
        return;
      }
      var error = "";
      if(Array.isArray(data.error_type) && data.error_type.length > 0 ){
        data.error_type.forEach(e=>{
          if(e.error_header){
            // Don't need to add a new header
          }else{
            error +=  ""+e.cell+"列"+e.row_no+"行目の"+e.field_label+"　"
          }
          error += "" + e.error + "<br><br>"
        })
      }
      if(Array.isArray(data.error_link) && data.error_link.length > 0 ){
        data.error_link.forEach(e=>{
          if(e.error_header){
            // Don't need to add a new header
          }else{
            error +=  ""+e.cell+"列"+e.row_no+"行目の"+e.field_label+"　"
          }
          error += "" + e.error + "<br><br>"
        })
      }
      this.$emit("onerror",error)
    },
    autoSizeAll(skipHeader) {
      setTimeout(() => {
        var allColumnIds = ["ci_certificate_management_number"];
        this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.gridOptions.columnApi.autoSizeAllColumns(allColumnIds, false);
      }, 100);
    },
    localInitLoadData(){
    },
    cancelRetractionReason(cb=()=>{}){
      this.retractionReasonValue = this.initialRetractionReason;
      this.disableRetractionReason = true
      if(Array.isArray(this.cancelableArr) && this.cancelableArr.length > 0){
        this.cancelableArr.forEach(e => {
          _.remove(this.selectedRowArr,(a) => { return a.seq_id == e.seq_id})
          this.gridOptions.api.forEachNode((node) => {
            if (typeof node != "undefined" && typeof node.data != "undefined" && typeof node.data.seq_id != "undefined") {
              if (node.data.seq_id == e.seq_id) {
                node.data.is_selected = false;
              }
            }
          });
        })
      }
      this.gridOptions.api.refreshView();
    },
    onArraySelected(data){
      if(this.saveCheckEvent == false){
        return;
      }
      var seq_id = data.row.seq_id;
      var action = data.select_action;
      if(action == "check"){
        this.cancelableArr.push(data.row);
        this.disableRetractionReason = false;
        return
      }
      this.$ajax.post('/'  + this.api_name + '/check_control/' + action + "/" +seq_id+ "/" + this.sessionId , {}, (err, result) => {
      })
    },
    saveRetractionReason(cb=()=>{}){
      setTimeout(() => {
        var checked =[];
        if(Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0){
          checked = this.selectedRowArr.map(m=>{ return m.seq_id});
        }
        this.$ajax.post("/approval_history_batch_import/set_retraction_reason_by_res_id/" +this.sessionId ,{ref_id:this.sessionId,retraction_reason:this.retraction_reason_value,checked}, (err, data) => {
          if(err){
            var title = "予期しないエラーが発生し、登録が行えません";
            if(err && err.indexOf("::") == 0){
              title = err.replace("::","");
              err = ""
            }
            this.$notify({clean: true});
            var obj = {
              title: title,
              text:err,
              type: 'error',
              duration: 10000
            }
            this.$notify(obj);
            this.cancelRetractionReason(cb)
          }else{
            console.log("get_retraction_reason_by_res_id",{err,data})
            this.disableRetractionReason = true;
            this.initialRetractionReason = this.retraction_reason_value;
          }
          return cb(err,data)
        });
      }, 100);
    },
  },
  mounted() {
      var user_id = Vue.localStorage.get("userID") || "";
      this.$ajax.post('/approval_history_batch_import/get_checked_info/' +this.sessionId  , {ref_id:this.sessionId}, (err, result) => {
        if(result && result.qty > 0 && result.checked_user != user_id  && result.checked_user  != null && result.checked_user  != ''){
          this.localAllowCheckBox = false;
        }
        this.$ajax.post('/approval_history_batch_import/get_by_res_id/' +this.sessionId  , {ref_id:this.sessionId}, (err, result) => {
          this.retractionReasonValue = result.retraction_reason || "";
          this.initialRetractionReason = this.retractionReasonValue;
          if(result && result.approval_status == "差戻"){
            this.showConfirmedBtn = true;
            this.disableEditRetractionReason = true;
            this.approval_status = result.approval_status;
            this.DisableRetractionReasonBtn = true;
          }else if(result && result.approval_status == "確認済"){
            this.disableEditRetractionReason = true;
          }
          if(result && result.seq_id > -1){
            this.localSeqId = result.seq_id;
          }else{
            this.localSeqId = false;
          }
          this.countErrors = 0;
          this.$ajax.post('/'  + this.api_name + '/count_errors/' + this.sessionId , {}, (err, result) => {
            this.countErrors = result[0].qty
            if(this.countErrors > 0){
              this.showErrroCount();
            }
          })
        })
      })
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions, {suppressHorizontalScroll: false,suppressSizeToFit : false});
    var sessionId = this.$props.sessionId;
    this.downloadUrl = "/api/batch_import_export/download_imported_file/" + sessionId
    this.api_request_options = {sessionId:sessionId};
    this.localAllowCheckBox = this.$props.allowCheckBox == true;
    this.saveCheckEvent = false;
    this.initDatasource({
      loaded_cb:(err,result)=>{
        _.filter(result,(r)=>{ return r.checked == 1 }).forEach(e=>{
          this.onSelectedClickDatasource({},e)
        })
        this.saveCheckEvent = true;
          if(Array.isArray(result) && result.length > 0 && result[0].table_mode == 2){
            this.gridOptions.api.setColumnDefs(this.createColumnDefs("tabFieldList2"))
          }
      }
    });

  },
  props: ['sessionId','allowCheckBox']
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
.esma_form_label {
  background-color: #b4d5f1 !important;
  margin: 2px 0px !important;
  padding: 4px !important;
  font-size: 11px !important;
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// sub-table-temp-batch-import.vue?63bb4462